import { render, staticRenderFns } from "./LibraryAddMedia.vue?vue&type=template&id=bf2afea6&scoped=true&"
import script from "./LibraryAddMedia.vue?vue&type=script&lang=js&"
export * from "./LibraryAddMedia.vue?vue&type=script&lang=js&"
import style0 from "./LibraryAddMedia.vue?vue&type=style&index=0&id=bf2afea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2afea6",
  null
  
)

export default component.exports